<template>
  <div class="content-container flex-column">
    <div class="grid-x toolbar fixed">
      <div class="cell auto">
        <h4 class="no-margin toolbar-title">Kunde</h4>
      </div>
    </div>

    <router-link :to="{ name: 'KundeCardAdd' }" class="button action fixed right glyph">
      <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-person"></use></svg>
      <span>Ny Kunde</span>
    </router-link>

    <TheLoader :active="loading"/>
    <TheEmptyList v-if="!loading && items.length < 1" :title="'Ingen kunder'"  :large="true" :icon="'glyph-medium-object'"/>
    <table v-if="!loading && items.length > 0" class="large fixed clickable" style="width: 100%">
      <thead>
        <tr>
          <th>#</th>
          <th>Navn</th>
          <th>E-post</th>
          <th>Telefon</th>
          <th>Sperret</th>
          <th>Type</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in items" v-bind:key="item.Kundenr" @click="onKundeClick(item)">
          <td>
            <span class="icon-container">
              <span class="avatar small icon">
                <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-person"></use></svg>
              </span>
              <a href="javascript:;" class="primary-title">{{item.Kundenr}}</a>
            </span>
          </td>
          <td>{{item.full_name}}</td>
          <td>{{item.Email}}</td>
          <td>{{item.full_phone}}</td>
          <td>{{item.Sperret === 'T' ? 'Ja' : 'Nei'}}</td>
          <td>{{item.Bedrift ? 'Bedrift' : 'Privat'}}</td>
        </tr>
      </tbody>
    </table>

    <div class="pagination-container"  v-if="pages > 1">
      <paginate v-model="page"
        :page-count="pages"
        :page-range="11"
        :click-handler="setPage"
        :container-class="'pagination'"
        :prev-text="paginationArrow"
        :next-text="paginationArrow"
        :prev-class="'prev'"
        :next-class="'next'"
        >
      </paginate>
    </div>
  </div>
</template>

<script>
import KundeService from '@/services/KundeService'

export default {
  name: 'KundeList',
  data () {
    return {
      page: 0,
      pages: 1,
      items: [],
      loading: false
    }
  },
  // When component is created - set page
  created () {
    this.page = this.$route.query.page ? parseInt(this.$route.query.page) : 1
  },
  // When route is updated - i.e. on query param change and so on...
  beforeRouteUpdate: function (to, from, next) {
    // Get new page and run next
    this.page = to.query.page ? parseInt(to.query.page) : 1
    next()
  },
  // Watch changes of param page - and do the fetch
  watch: {
    page: function () {
      this.fetch()
    }
  },
  methods: {
    fetch: function (callback) {
      this.loading = true

      KundeService.index(this.page)
        .then((response) => {
          this.pages = response.headers['x-paging-pagecount'] ? parseInt(response.headers['x-paging-pagecount']) : 1
          this.items = response.data

          if (callback) {
            callback()
          }
        })
        .catch(() => {
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste inn kundeliste')
        })
        .then(() => {
          this.loading = false
        })
    },
    setPage: function (pageNum) {
      if (pageNum > 1) {
        this.$router.replace({ name: this.$route.name, query: {page: pageNum} })
      } else {
        this.$router.replace({ name: this.$route.name })
      }
    },
    onKundeClick: function (item) {
      this.$router.push({name: 'KundeCard', params: {kunde_id: item.Kundenr}})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeList.vue